// The `letter*` keys are the client's copy, transcribed character for character — including
// the `XXX` / `XX` debate date and time, which are theirs to fill in Lokalise before launch.
// One deliberate edit: their bare `INSERT YOUR NAME` / `INSERT YOUR POSTCODE` were given the
// brackets the other two tokens already had, so all four read alike.
// One key per line; the paragraph and bullet grouping is layout, in `MpLetter.vue`.
export default {
  title: {
    id: 'rm_take_action_mp_letter_title',
    defaultMessage: 'Ask your MP to attend',
  },
  intro: {
    id: 'rm_take_action_mp_letter_intro',
    defaultMessage:
      'Email your MP and ask them to attend the event and speak out in support of technology that lasts longer, costs less, and is easier to repair and refurbish.',
  },
  step1: {
    id: 'rm_take_action_mp_letter_step_1',
    defaultMessage:
      'Find your MP’s email address using your postcode: [Find your MP](https://members.parliament.uk/FindYourMP)',
  },
  step2: {
    id: 'rm_take_action_mp_letter_step_2',
    defaultMessage: 'Copy and paste the email below, then send it to them.',
  },

  formLabel: {
    id: 'rm_take_action_mp_letter_form_label',
    defaultMessage: 'Personalise your email',
  },
  mpNameLabel: {
    id: 'rm_take_action_mp_letter_mp_name_label',
    defaultMessage: "Your MP's name",
  },
  constituencyLabel: {
    id: 'rm_take_action_mp_letter_constituency_label',
    defaultMessage: 'Your constituency',
  },
  yourNameLabel: {
    id: 'rm_take_action_mp_letter_your_name_label',
    defaultMessage: 'Your name',
  },
  postcodeLabel: {
    id: 'rm_take_action_mp_letter_postcode_label',
    defaultMessage: 'Your postcode',
  },

  copyCta: {
    id: 'rm_take_action_mp_letter_copy_cta',
    defaultMessage: 'Copy the email',
  },
  copiedCta: {
    id: 'rm_take_action_mp_letter_copied_cta',
    defaultMessage: 'Copied!',
  },
  copyError: {
    id: 'rm_take_action_mp_letter_copy_error',
    defaultMessage:
      'Copying is unavailable here — select the text below and copy it manually.',
  },

  mpNamePlaceholder: {
    id: 'rm_take_action_mp_letter_mp_name_placeholder',
    defaultMessage: "[INSERT YOUR MP'S NAME]",
  },
  constituencyPlaceholder: {
    id: 'rm_take_action_mp_letter_constituency_placeholder',
    defaultMessage: '[INSERT CONSTITUENCY]',
  },
  yourNamePlaceholder: {
    id: 'rm_take_action_mp_letter_your_name_placeholder',
    defaultMessage: '[INSERT YOUR NAME]',
  },
  postcodePlaceholder: {
    id: 'rm_take_action_mp_letter_postcode_placeholder',
    defaultMessage: '[INSERT YOUR POSTCODE]',
  },

  letterGreeting: {
    id: 'rm_take_action_mp_letter_greeting',
    defaultMessage: 'Dear {mpName},',
  },
  letterConstituent: {
    id: 'rm_take_action_mp_letter_constituent',
    defaultMessage:
      'As one of your constituents of {constituency} I am writing to encourage you to participate in a forthcoming Westminster Hall debate about the benefits of refurbished tech and solutions to make smartphones last for longer.',
  },
  letterPartnership: {
    id: 'rm_take_action_mp_letter_partnership',
    defaultMessage:
      "I also want to draw your attention to Back Market's Mine My Phone Campaign in partnership with [Green Alliance].",
  },
  letterDebateDetails: {
    id: 'rm_take_action_mp_letter_debate_details',
    defaultMessage:
      "The debate will take place on XXX at XXX. It is titled 'That this House has considered the benefits of prolonging the life of smartphones through refurbishment and restoration.'",
  },
  letterCampaignAim: {
    id: 'rm_take_action_mp_letter_campaign_aim',
    defaultMessage:
      'This campaign is seeking to debate implementing solutions which will empower people to make their smartphone last at least 10 years by choosing refurbished, repairing and reselling when they need to.',
  },
  letterAffordability: {
    id: 'rm_take_action_mp_letter_affordability',
    defaultMessage:
      'The benefits of prolonging the life of smartphones include making devices more affordable for customers, and therefore reducing the amount of people who are digitally excluded by the high cost of technology. A refurbished smartphone costs up to 70% less than a new device!',
  },
  letterResources: {
    id: 'rm_take_action_mp_letter_resources',
    defaultMessage:
      "Crucially, new smartphones have a significant impact on the earth's resources, using up critical minerals, precious metals and burning fossil fuels in factories to assemble microchips.",
  },
  letterHumanCost: {
    id: 'rm_take_action_mp_letter_human_cost',
    defaultMessage:
      'This is not to mention the human and social costs of this extraction.',
  },
  letterRefurbished: {
    id: 'rm_take_action_mp_letter_refurbished',
    defaultMessage:
      'Buying refurbished means that this process is interrupted, with a refurbished devices reducing raw material extraction by around 91% compared with purchasing new products and reducing carbon footprint by around 87%.',
  },
  letterManufacturing: {
    id: 'rm_take_action_mp_letter_manufacturing',
    defaultMessage:
      "Manufacturing accounts for around 40% of digital technology's carbon footprint, making lifetime extension one of the most effective interventions available, while costing less to produce, and therefore meaning a lower price for the customer.",
  },
  letterUrgeToSpeak: {
    id: 'rm_take_action_mp_letter_urge_to_speak',
    defaultMessage:
      'As my local MP, I urge you could engage with this campaign, and speak in the debate on XX on behalf of the people of {constituency}.',
  },
  letterConsiderFollowing: {
    id: 'rm_take_action_mp_letter_consider_following',
    defaultMessage: 'Specifically, please could you consider the following:',
  },
  letterQuestion1: {
    id: 'rm_take_action_mp_letter_question_1',
    defaultMessage:
      'Does the Government recognise the financial benefits for consumers of ensuring that smartphones last 10 years?',
  },
  letterQuestion2: {
    id: 'rm_take_action_mp_letter_question_2',
    defaultMessage:
      'Does the Government recognise the critical mineral cost and supply challenges of manufacturing new smartphones?',
  },
  letterQuestion3: {
    id: 'rm_take_action_mp_letter_question_3',
    defaultMessage:
      'What policy reforms is the Government considering to ensure that consumers are not only aware of the existing avenues available to them to buy refurbished or repaired devices rather than new but also support the environment that enables giving devices a second or third life?',
  },
  letterQuestion4: {
    id: 'rm_take_action_mp_letter_question_4',
    defaultMessage:
      'How can Government support those who are digitally excluded due to the cost of new technology to access repaired or refurbished technology so that they have greater access to services they need?',
  },
  letterParliamentaryQuestions: {
    id: 'rm_take_action_mp_letter_parliamentary_questions',
    defaultMessage:
      'If you are unable to raise these questions in the Westminster Hall debate, I would be grateful if you could table these as Parliamentary Questions instead.',
  },
  letterSignOff: {
    id: 'rm_take_action_mp_letter_sign_off',
    defaultMessage: 'Yours sincerely,',
  },
  letterYourName: {
    id: 'rm_take_action_mp_letter_your_name',
    defaultMessage: '{yourName}',
  },
  letterYourPostcode: {
    id: 'rm_take_action_mp_letter_your_postcode',
    defaultMessage: '{postcode}',
  },
} as const
